import { Config } from "../../core/config/config";
import React from "react";

const translations_tickets = {
    get noEntries() {
        return __internal_translations["Standard.Msg.KeineErgebnisse"];
    },
    get openInNewTab() {
        return __internal_translations["WebSMS.Common.OpenInNewTab"];
    },
    get telephone() {
        return __internal_translations["Field.Adresse.telefon"];
    },
    get email() {
        return __internal_translations["Field.Ressource.email1"];
    }
};
const colors={
    materialCardBackgroundColor:"rgb(0,121,107)"
}

function generateCustomDataMap(r){
    let map = new Map<string, string>();
    map.set('DAYSUNTILDUE', r.DAYSUNTILDUE);
    map.set('SLA_FULFILLED', r.SLA_FULFILLED);
    return map;
}

class RowNumberCustom extends React.Component<rowData,any>{
    render(){
        let daysUntilDue = parseInt(String(this.props.CUSTOM_DATA.get('DAYSUNTILDUE')));
        let slaFulfilled = parseInt(String(this.props.CUSTOM_DATA.get('SLA_FULFILLED')));
        return <>
            <span style={{fontStyle: "italic", fontWeight: "bold", fontSize: "15px", color: "#4a4a4a", fontFamily: "Roboto"}}>
                {
                    (daysUntilDue > 1)
                    ? (
                        <>
                        <i className="fa fa-exclamation-triangle" style={{color: "green", fontSize: "25px", fontWeight: 400}}></i>
                        </>
                    )
                    : (daysUntilDue === 1)
                    ? (
                        <>
                        <i className="fa fa-exclamation-triangle" style={{color: "#ffB000", fontSize: "25px", fontWeight: 400}}></i>
                        </>
                    ): (daysUntilDue < 0)
                    ? (
                        <>
                        <i className="fa fa-exclamation-triangle" style={{color: "red", fontSize: "25px", fontWeight: 400}}></i>
                        </>
                       ): (
                        <>
                        
                        </>
                    )
                        
                    
                }
                {
                    (slaFulfilled === 0)
                    ? (
                        <>
                        <i className="fa fa-exclamation-triangle" style={{color: "indianred", fontSize: "25px", fontWeight: 400}}></i>
                        </>
                    )
                    : (slaFulfilled === 1)
                    ? (
                        <>
                        <i className="fa fa-check-square" style={{color: "#64dd17"}}></i>
                        </>
                    ): null
                }
            </span>
        </>
    }
}

class NoEntries extends React.Component<any, any>{
    render() {
        return <div className="material-card-container">
            <div style={{ textAlign: "center", color: "#000000", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#FFFFFF", opacity: "0.5"}}>
                <i className="fal fa-empty-set" style={{fontSize: "5em", marginBottom: "10px"}}></i>
                <div style={{fontFamily: "Roboto"}}>{translations_tickets.noEntries}</div>
            </div>
        </div>
    }
}

interface rowData{
    ENTRY_DATE:string;
    ENTRY_EMAIL:string;
    ENTRY_LINK:string;
    ENTRY_NUMBER:string;
    ENTRY_PHONE:string;
    TOOLTIP_AP:string;
    ENTRY_SUBTITLE:string;
    ENTRY_TITLE:string;
    CUSTOM_DATA:Map<string, string>;
    ENTRY_DESCRIPTION: string;
    ENTRY_STATUS: string;
    ENTRY_DOC_ISGUID:string;
    PERSONRESPONSIBLE:string;
    onclick:any;
    isSelected?:boolean;
}


class Row extends React.Component<rowData,any>{
    openLink =()=>{
        if (this.props.ENTRY_LINK && (this.props.ENTRY_LINK != "")) window.open(Config.baseUrl + this.props.ENTRY_LINK, "_blank");
    }

    stopPropagation =(e)=>{
        e.stopPropagation();
    }


    render(){
     
        return <div style={{borderLeft:this.props.isSelected?"5px solid rgb(0,121,107)":"5px solid #ffffff", backgroundColor: "#ffffff", borderBottom: "1px solid #cccccc"}} className="material-card material-card-clickable" onClick={()=>this.props.onclick(this.props.ENTRY_DOC_ISGUID)}>

            <div className="grid-item-tickets1" style={{gridArea: "buttonOeffnen"}} onClick={this.openLink}>
                <span className="external buttonIcon_tickets" style={{height: "30px", width: "30px"}}>
                    <i style={{fontSize: "20px", fontWeight: 400, alignItems: "center", justifyContent: "center"}} className="far fa-external-link" title={translations_tickets.openInNewTab}></i>
                </span>
            </div>

            <div className="grid-item-tickets7" style={{gridArea: "iconUeberfaellig", marginLeft: "auto", marginRight: "auto"}}>
                <RowNumberCustom{... this.props}></RowNumberCustom>
            </div>
        
            <div className= "grid-item-tickets2" style={{gridArea: "erstellDatum", marginLeft: "auto", marginRight: "auto"}}> 
                {
                    (this.props.ENTRY_DATE != "")
                    ? (
                        <span style={{color: "black", fontFamily: "Roboto"}}>
                            {kendo.toString(kendo.parseDate(this.props.ENTRY_DATE), 'd')}
                        </span>
                    )
                    : null
                }
            </div>
            
            <div className="grid-item-tickets10" style={{gridArea: "hotliner"}}>
                <span style={{fontWeight: "bold", fontSize: "15px", color: "black", fontFamily: "Roboto"}}>  
                    {this.props.PERSONRESPONSIBLE}
                </span>
            </div>

            <div className="grid-item-tickets8" style={{gridArea: "problemNr"}}>
                <span style={{color: "#4a4a4a", fontWeight: "bold", fontFamily: "Roboto"}}>
                    {this.props.ENTRY_NUMBER}
                </span>
            </div>
            
            <div className="grid-item-tickets3" style={{ gridArea: "titel" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px", color: "black", fontFamily: "Roboto" }} className="truncate" title={this.props.ENTRY_TITLE }>
                    {this.props.ENTRY_TITLE}
                </span>
            </div>

            <div className="grid-item-tickets9" style={{gridArea: "subtitel"}}>
                <span style={{fontFamily: "Roboto"}}>
                  {this.props.ENTRY_SUBTITLE}
                </span>
            </div>
        
            <div className= "grid-item-tickets4" style={{gridArea: "gridBeschreibung"}}>
                <span style={{fontWeight: "bold", fontSize: "15px", color: "black", fontFamily: "Roboto"}}>
                  {this.props.ENTRY_DESCRIPTION}
                </span>
            </div>

            <div className= "grid-item-tickets11" style={{gridArea: "gridStatus"}}>
                <span style={{color: "#4a4a4a", fontWeight: "bold", fontFamily: "Roboto"}}>
                {this.props.ENTRY_STATUS}
                </span>
            </div>

            <div className="grid-item-tickets5" style={{gridArea: "buttonPhone"}}>
                {
                    (this.props.ENTRY_PHONE != "")
                    ? (
                    <span className="" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "30px", width: "30px"}}>
                        <a href={this.props.ENTRY_PHONE ? "tel:" + this.props.ENTRY_PHONE : ""} target="_blank" style={{textDecoration: "none", color: "black"}}>
                            <i className ="icon-phone fa-thin fa-phone buttonIcon_tickets" style={{fontSize: "25px", fontWeight: 400}} 
                                title={`${this.props.TOOLTIP_AP}\r\n${translations_tickets.telephone} : ${this.props.ENTRY_PHONE}`}>
                            </i>
                        </a>
                    </span>
                    )
                    :
                    (
                    <span className="icon-phone-NoData" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "30px", width: "30px"}}>
                            <i className ="fa-thin fa-phone" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}}></i>
                    </span>
                    )
                }
            </div>

            <div className="grid-item-tickets6" style={{gridArea: "buttonMail"}}>
                {
                    (this.props.ENTRY_EMAIL != "")
                    ? (
                    <span className="" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "30px", width: "30px"}}>
                        <a href={this.props.ENTRY_EMAIL ? "mailto:" + this.props.ENTRY_EMAIL : ""} target="_blank" style={{textDecoration: "none", color: "black"}}>
                            <i className="icon-envelope fa-thin fa-envelope buttonIcon_tickets" style={{fontSize: "25px", fontWeight: 400}}
                                title={`${this.props.TOOLTIP_AP}\r\n${translations_tickets.email} : ${this.props.ENTRY_EMAIL}`}>
                            </i>
                        </a>
                    </span>
                    )
                    :
                    (
                        <span className="icon-envelope-noData" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "30px", width: "30px"}}>
                            <i className="fa-thin fa-envelope" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}}></i>
                        </span>
                    )
                }
            </div>
        </div>

    }
}





export class CompMain extends React.Component<any, {activeIndex:number,docGuid?:string}>{
    constructor(props,state){
        super(props,state);
        this.state={activeIndex:0};
        document.addEventListener("visibilitychange",()=>{this.props.api.reloadStatistic()})
    }

    refreshStatistic=()=>{
        window["DelphiInterop"].statisticWidgets[this.props.context.STATISTIC_WIDGET_ID].api.reload();
    }

    handlePageChanged = (pageIndex) => {
        this.setState({activeIndex:pageIndex});
    }
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ activeIndex: number; docGuid?: string; }>, snapshot?: any): void {
        if(this.props.data!=prevProps.data){
            this.setState({activeIndex:0})
        }
    }
    
    render() {
        const cssProps:React.CSSProperties = {display:"inline-flex"};
        const filteredData = this.props.data?.filter((e,i)=>i>=this.state.activeIndex * 7 && i < (this.state.activeIndex+1)*7);
        return <>
            <style>{css}</style>
            <div className="material-card-list">
                    
               
                {this.props.data && this.props.data.length==0 ? <NoEntries></NoEntries>:null}
                <div className="material-card-container">
                    {filteredData.map((r)=><Row
                        isSelected ={this.state.docGuid ? this.state.docGuid == r.ENTRY_DOC_ISGUID : false}
                        ENTRY_DATE={r.ENTRY_DATE ? r.ENTRY_DATE : ""} 
                        ENTRY_EMAIL={r.ENTRY_EMAIL ? r.ENTRY_EMAIL : ""}
                        ENTRY_LINK={r.ENTRY_LINK ? r.ENTRY_LINK : ""}
                        ENTRY_NUMBER={r.ENTRY_NUMBER ? r.ENTRY_NUMBER : ""}
                        ENTRY_PHONE={r.ENTRY_PHONE ? r.ENTRY_PHONE : ""}
                        TOOLTIP_AP={r.TOOLTIP_AP ? r.TOOLTIP_AP : ""}
                        ENTRY_SUBTITLE={r.ENTRY_SUBTITLE ? r.ENTRY_SUBTITLE : ""}
                        ENTRY_TITLE={r.ENTRY_TITLE ? r.ENTRY_TITLE : ""}
                        CUSTOM_DATA={generateCustomDataMap(r)}
                        ENTRY_DESCRIPTION={r.ENTRY_DESCRIPTION ? r.ENTRY_DESCRIPTION : ""}
                        ENTRY_STATUS={r.ENTRY_STATUS ? r.ENTRY_STATUS : ""}
                        ENTRY_DOC_ISGUID={r.ENTRY_DOC_ISGUID ? r.ENTRY_DOC_ISGUID : ""}
                        PERSONRESPONSIBLE={r.PERSONRESPONSIBLE ? r.PERSONRESPONSIBLE : ""}
                        onclick={(docGuid)=>{this.setState({docGuid:docGuid})}}
                    ></Row>)}
                </div>
            </div>
            <Pager data={this.props.data} activeIndex={this.state.activeIndex} onPageChanged={this.handlePageChanged}/>
        </>
    }
}
class Pager extends React.Component<{activeIndex:number,onPageChanged, data:any[]},any>{
    private pagerDiv:HTMLDivElement;
    private kendoPager;

    handlePageClick = (pageIndex:number) => {
        this.props.onPageChanged(pageIndex);
    }

    componentDidMount(): void {
        const dataSource = new kendo.data.DataSource({
            data: this.props.data,
            pageSize: 7,
          });
             
          
          const that = this;
          this.kendoPager =  $(this.pagerDiv).kendoPager({
            dataSource: dataSource,            
            change: function() {
              that.props.onPageChanged(this.page()-1);
            }
          }).data("kendoPager");
          const p = this.kendoPager.setDataSource(dataSource);

    }
    componentWillUnmount(): void {
        this.kendoPager.destroy();
    }

    componentDidUpdate(prevProps: Readonly<{ activeIndex: number; onPageChanged: any; data: any[]; }>, prevState: Readonly<any>, snapshot?: any): void {
        if(this.props.data !== prevProps.data){  
        const dataSource = new kendo.data.DataSource({
            data: this.props.data,
            pageSize: 7            
          });
        const p = this.kendoPager.setDataSource(dataSource);
        }
    }

    renderPager=()=>{
        const aa:any[] = [];
        for(let i=0;i<=(this.props.data.length / 7);i++){
            aa.push(<a onClick={()=>this.handlePageClick(i)} className={i==this.props.activeIndex?"active":""} style = {{color: "black"}}>{i+1}</a>)
        }
        return aa;
    }

    render(){
        return <div style={{position: "sticky", bottom: "0px"}} id="hallo" ref={(e)=>this.pagerDiv = e}></div>
    }
}

const css = `
    .pagination {
        display: grid;
        grid-template-columns: auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 40px;
    }

     .pagination > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
    }

    .pagination a.active {
        background-color: rgb(0, 121, 107);
        color: green;
    }

    .pagination a:hover:not(.active) {background-color: #ddd; color: green}

    .grid-item-tickets1, .grid-item-tickets5, .grid-item-tickets7, .grid-item-tickets6 {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .grid-item-tickets2, .grid-item-tickets3, .grid-item-tickets8, .grid-item-tickets9, .grid-item-tickets10, grid-item-tickets11{
        display: flex;
        align-items: center;
    }

    .grid-item-tickets4 > span, grid-item-tickets11 > span {
        text-align: center;
    }

    .grid-item-tickets4 {
        margin-right: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .material-card{
        border: none;
        display: grid;
        background-color: #2196f3;

        grid-template-areas: 
        'buttonOeffnen iconUeberfaellig hotliner titel gridBeschreibung buttonPhone buttonMail'
        'buttonOeffnen erstellDatum problemNr subtitel gridStatus buttonPhone buttonMail' ;

        grid-template-columns: 60px 140px 170px 280px 170px 60px 60px;
        grid-template-rows: 34px 34px;
    }

    @media only screen and (max-width: 480px) {
        
        .material-card{
            grid-template-areas: 
            'buttonOeffnen hotliner gridBeschreibung buttonPhone'
            'iconUeberfaellig problemNr gridStatus buttonPhone' ;

            grid-template-columns: 60px 80px 140px 60px auto;
            grid-template-rows: auto;
        }

        .grid-item-tickets4 > span, .grid-item-tickets10 > span{
            text-align: left;
        }

        .grid-item-tickets8 > span, .grid-item-tickets11 > span {
            text-align: left;
            padding-top: 5px;
        }

        .grid-item-tickets4, .grid-item-tickets8, .grid-item-tickets10, .grid-item-tickets11 {
            display: flex;
            align-items: unset;
        }

        .grid-item-tickets1, .grid-item-tickets7{
            display:flex;
        }

        .grid-item-tickets2, .grid-item-tickets3, .grid-item-tickets6, .grid-item-tickets9 {
            display:none;
        }
    }

    .icon-envelope {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
    }

    .icon-phone {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
    }

    .external {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 50px;
        border: 1px solid transparent;
        transition: border-color 0.3s ease; 
    }

    .buttonIcon_tickets {
        transition: all .3s ease-in-out;
    }

    .buttonIcon_tickets:hover {
        cursor: pointer;
        transform: scale(1.3);
        color: rgb(0,121,107);
    }

    .material-card material-card-clickable > div{
        text-align: center;
        padding: 20px 0; 
        font-size: 30px;
    }

    .material-card-list{
        font-family: Open Sans;
        line-height: 1.4;
        height: 502px;
    }


    .material-header-title{
        display: grid;
        grid-template-columns: auto auto auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 55px;
    }

    .material-header-title > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }
    
    .material-card-container{
        max-height: 520px;
        overflow: auto;
    }

   .refresh {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 50px;
        border: 1px solid transparent;
        transition: border-color 0.3s ease; 
    }

    .refresh:hover {
        border-color: rgb(0, 121, 107); 
        color: rgb(0, 121, 107);
    }

    .material-card material-card-clickable{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #cccccc",
        transition: "background-color 0.3s ease",
    }

    .material-card material-card-clickable:hover{
        background-color: #e3e3e3;
    }

    .material-div-link {
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        left: 0;
        z-index: 1;
    }

}
`